import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/logo.png'
import _imports_1 from '@/assets/logo-srp-combinated.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-053bd967")

_pushScopeId("data-v-053bd967")
const _hoisted_1 = { class: "principal" }
const _hoisted_2 = { class: "navbar navbar-expand-md navbar-light headerSRP" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("a", {
    class: "navbar-brand",
    href: "#"
  }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_0,
      class: "d-inline-block align-top logoHir",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createVNode("h2", { class: "d-inline tituloHeader display-4" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_1,
      alt: "logo"
    })
  ])
], -1)
const _hoisted_4 = { class: "divOpciones" }
const _hoisted_5 = { class: "dropdown" }
const _hoisted_6 = /*#__PURE__*/_createVNode("i", {
  class: "fa fa-user",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "oi oi-person" }, null, -1)
const _hoisted_8 = {
  class: "btn btn-primary dropdown-toggle",
  type: "button",
  id: "dropdownMenuButton1",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "fas fa-chevron-down" }, null, -1)
const _hoisted_10 = {
  class: "dropdown-menu",
  "aria-labelledby": "dropdownMenuButton1",
  id: "dropdown-rol"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "dropdown-divider" }, null, -1)
const _hoisted_12 = {
  class: "dropdown-item",
  href: "#"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "fas fa-power-off iconoCerrarSesion" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Cerrar sesión ")
const _hoisted_15 = {
  id: "navDashboard",
  class: "navbar navbar-expand-lg navbar-light"
}
const _hoisted_16 = {
  class: "collapse navbar-collapse",
  id: "navbarNav"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("li", { class: "nav-item liNavBar" }, [
  /*#__PURE__*/_createVNode("a", {
    id: "enlaceRegresar",
    class: "nav-link",
    href: "javascript: history.go(-1)"
  }, [
    /*#__PURE__*/_createVNode("i", { class: "far fa-arrow-alt-circle-left" }),
    /*#__PURE__*/_createVNode("h6", null, "Regresar")
  ])
], -1)
const _hoisted_18 = { class: "nav-item liNavBar" }
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "fas fa-solar-panel" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Dashboard")
const _hoisted_21 = { class: "nav-item liNavBar" }
const _hoisted_22 = /*#__PURE__*/_createVNode("i", { class: "fas fa-file-invoice" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Requisiciones")
const _hoisted_24 = { class: "nav-item liNavBar" }
const _hoisted_25 = /*#__PURE__*/_createVNode("i", { class: "fas fa-history" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Histórico")
const _hoisted_27 = {
  key: 0,
  class: "nav-item liNavBar"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("i", { class: "fas fa-chalkboard-teacher" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Carrusel")
const _hoisted_30 = {
  key: 1,
  class: "nav-item liNavBar"
}
const _hoisted_31 = /*#__PURE__*/_createVNode("i", { class: "fas fa-list-ol" }, null, -1)
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Códigos de presupuesto")
const _hoisted_33 = {
  key: 2,
  class: "nav-item liNavBar btn-nav"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_BotonPrimario = _resolveComponent("BotonPrimario")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("nav", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _createVNode("button", _hoisted_8, [
            _createTextVNode(_toDisplayString(_ctx.nombreLogin) + " ", 1),
            _hoisted_9
          ]),
          _createVNode("ul", _hoisted_10, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.roles, (rol, index) => {
              return (_openBlock(), _createBlock("li", {
                style: {"cursor":"pointer"},
                key: index
              }, [
                _createVNode("a", {
                  style: {"width":"100%"},
                  class: ["dropdown-item", { acitve: rol == _ctx.rolElegido }],
                  onClick: [
                    _withModifiers(($event: any) => (_ctx.EditarSolicitud(rol)), ["prevent"]),
                    ($event: any) => (_ctx.opcion = rol)
                  ],
                  id: rol
                }, _toDisplayString(rol), 11, ["onClick", "id"])
              ]))
            }), 128)),
            _createVNode("li", null, [
              _hoisted_11,
              _createVNode("a", _hoisted_12, [
                _createVNode("button", {
                  title: "Cerrar sesión",
                  id: "btnCerrarSesion",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.CerrarSesion && _ctx.CerrarSesion(...args)))
                }, [
                  _hoisted_13,
                  _hoisted_14
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("nav", _hoisted_15, [
      _createVNode("div", _hoisted_16, [
        _createVNode("ul", {
          class: "navbar-nav tabs",
          hidden: _ctx.rol
        }, [
          _hoisted_17,
          _createVNode("li", _hoisted_18, [
            _createVNode(_component_router_link, {
              to: { name: 'srp-requisicion-pago-dashboard' },
              class: "nav-link",
              "active-class": "active"
            }, {
              default: _withId(() => [
                _hoisted_19,
                _hoisted_20
              ]),
              _: 1
            })
          ]),
          _createVNode("li", _hoisted_21, [
            _createVNode(_component_router_link, {
              to: { name: 'srp-requisicion-pago-historico', params: { rolUsuario: _ctx.rolElegido } },
              class: "nav-link",
              "active-class": "active"
            }, {
              default: _withId(() => [
                _hoisted_22,
                _hoisted_23
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createVNode("li", _hoisted_24, [
            _createVNode(_component_router_link, {
              to: { name: 'srp-requisicion-pago-requisiciones', params: { rolUsuario: _ctx.rolElegido } },
              class: "nav-link",
              "active-class": "active"
            }, {
              default: _withId(() => [
                _hoisted_25,
                _hoisted_26
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          (_ctx.opcion == 'Autorizador CXP' || _ctx.opcion == 'Verificador CXP')
            ? (_openBlock(), _createBlock("li", _hoisted_27, [
                _createVNode(_component_router_link, {
                  to: { name: 'srp-requisicion-pago-requisiciones-carrusel', params: { rolUsuario: _ctx.rolElegido } },
                  class: "nav-link",
                  "active-class": "active"
                }, {
                  default: _withId(() => [
                    _hoisted_28,
                    _hoisted_29
                  ]),
                  _: 1
                }, 8, ["to"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.opcion == 'Planeación Financiera')
            ? (_openBlock(), _createBlock("li", _hoisted_30, [
                _createVNode(_component_router_link, {
                  to: { name: 'srp-requisicion-pago-catalogo-codigos' },
                  class: "nav-link",
                  "active-class": "active"
                }, {
                  default: _withId(() => [
                    _hoisted_31,
                    _hoisted_32
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.opcion == 'Verificador CXP')
            ? (_openBlock(), _createBlock("li", _hoisted_33, [
                _createVNode(_component_BotonPrimario, {
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.ActualizarNav()), ["prevent"])),
                  cargando: _ctx.estaActualizandoNav,
                  icono: "fas fa-sync",
                  color: "btn-primary text-white",
                  texto: "Actualizar NAV",
                  mensaje: "Actualizando",
                  id: "btn-actualizar-nav",
                  hidden: _ctx.esNuevaRequisicion
                }, null, 8, ["cargando", "hidden"])
              ]))
            : _createCommentVNode("", true)
        ], 8, ["hidden"])
      ])
    ])
  ]))
})